/**
 * ExchangeAccount Entity Definition
 */
import { ExchangeAccountRelationSchema } from "../schemas/relations";
import { defineEntity } from "./core";
import { ExchangeEntityDef } from "./exchange.entity";
import { getLazyBotConfigEntityDef, getLazyUserEntityDef } from "./lazy-refs";
export const ExchangeAccountEntityDef = defineEntity({
    name: "exchange-account",
    schema: ExchangeAccountRelationSchema,
    relations: {
        exchange: { type: "one", entity: () => ExchangeEntityDef },
        user: { type: "one", entity: getLazyUserEntityDef },
        bot_configs: { type: "many", entity: getLazyBotConfigEntityDef },
    },
});
